export default __webpack_public_path__ + "static/media/hero-connection-bg.9863f55e.jpg";